export default __webpack_public_path__ + "static/media/middle-screen.7429ab90.png";